import { eTaskPeriod } from "../contracts/enums/period.enum";

export const TASKS_PERIOD_OPTIONS: {id: number, text: string, isDisabled?: boolean}[] = [
    {
        id: eTaskPeriod.ALL,
        text: "Todos"
    },
    {
        id: eTaskPeriod.OVERDUE,
        text: "Em atraso"
    },
    {
        id: eTaskPeriod.THIS_WEEK,
        text: "Esta semana"
    },
    {
        id: eTaskPeriod.TODAY,
        text: "Hoje"
    },
    {
        id: eTaskPeriod.TOMORROW,
        text: "Amanhã"
    },
    {
        id: eTaskPeriod.FUTURE,
        text: "Futuros"
    },
]